<template>
  <transition v-if="value" name="modal">
    <div class="modalcon">
      <div class="modal-mask" @click="close">
        <div class="modal-wrapper">
          <div class="modal-container" @click.stop>
           <span class="closebtn" @click="close">
             <span class="closebtn" @click="close">
               <i class="fa fa-close" aria-hidden="true"></i>
             </span>
           </span>
            <div class="clearfix"></div>
            <div class="mbox">
              <div class="modal-header prelative justify-content-center">
                <form method="POST" v-on:submit.prevent="updateProfile" enctype="form-data" action="">
                  <div class="form-group" :class="{error: validation.hasError('birthdate')}">
                    <label>Date of Birth *</label>
                    <div class="input-group date customdate" data-provide="datepicker">
                      <input type="text" class="form-control" name="birthdate" v-model="user.birthdate" disabled
                              v-if="!(user.birthdate == '0000-00-00')">
                      <datepicker input-class="form-control tranparent" v-model="birthdate" name="birthdate"
                                  placeholder="Please enter your birthdate"
                                  v-else></datepicker>
                      <div class="input-group-addon">
                        <span class="fa fa-calendar"></span>
                      </div>
                    </div>
                    <div class="message">{{ validation.firstError('birthdate') }}</div>
                  </div>
                  <div class="form-check row" :class="{error: validation.hasError('gender')}">
                    <div class="col-sm-12">
                      <label class="form-check">
                        Gender * &nbsp; &nbsp;
                      </label>
                    </div>
                    <div class="col-sm-12">
                      <label class="custom-control custom-radio">
                        <input id="radio1" name="radio" type="radio" class="custom-control-input" value="M" v-model="gender">
                        <span class="custom-control-indicator"></span>
                        <span class="custom-control-description">Male</span>
                      </label>
                      <label class="custom-control custom-radio">
                        <input id="radio2" name="radio" type="radio" class="custom-control-input" value="F" v-model="gender">
                        <span class="custom-control-indicator"></span>
                        <span class="custom-control-description">Female</span>
                      </label>
                      <label class="custom-control custom-radio">
                        <input id="radio3" name="radio" type="radio" class="custom-control-input" value="Others" v-model="gender">
                        <span class="custom-control-indicator"></span>
                        <span class="custom-control-description">Other</span>
                      </label>
                      <div class="message">{{ validation.firstError('gender') }}</div>
                    </div>
                  </div>
                  <div class="form-check row">
                    <div class="col-12">
                      <button class="btn  btn-outline-primary w45 text-uppercase btn-sm pull-right ptb10" @click="close">Cancel</button>
                      <button 
                        type="submit" 
                        class="btn btn-primary w45 pointer text-uppercase btn-sm ptb10"
                      >Save</button> &nbsp;
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  import SimpleVueValidation from 'simple-vue-validator'
  import { mapGetters } from 'vuex'
  import Datepicker from 'vuejs-datepicker'

  var Validator = SimpleVueValidation.Validator
  var $ = require('jquery')
  window.jQuery = $
  export default {
    props: {
      value: {
        required: true
      }
    },
    data () {
      return {
        registerDetails: {},
        gender: '',
        birthdate: '',
        submitted: false,
        error: ''
      }
    },
    validators: {
      gender: function (value) {
        return Validator.value(this.gender).required()
      },
      birthdate: function (value) {
        let bd = (this.user.birthdate === '0000-00-00') && !this.birthdate ? null : this.strbirthdate || this.user.birthdate
        let time1 = new Date(bd).getTime()
        let time2 = new Date().getTime()
        return Validator.custom(function () {
          if (!bd) {
            return 'Required'
          }
          if (time1 === 0 || time1 > time2) return 'Please enter correct DOB.'
        })
      }
    },
    methods: {
      updateProfile () {
        this.$validate().then((success) => {
          if (success) {
            let profile = {
              firstname: this.user.firstname,
              lastname: this.user.lastname,
              gender: this.gender,
              birthdate: this.strbirthdate || this.user.birthdate,
              telephone: this.user.telephone,
              is_two_fa: this.user.is_two_fa
            }
            this.$store.dispatch('USER_SAVE', profile).then((user) => {
              this.close()
            })
          }
        })
      },
      close () {
        this.$emit('closeModal')
      }
    },
    components: {Datepicker},
    computed: {
      ...mapGetters(['authLoading', 'genderDOBModal', 'USER']),
      user: function () {
        let user = this.$store.getters.user
        if (user && !['Others', 'M', 'F'].includes(user.gender)) {
          this.gender = 'M'
        } else this.gender = user.gender
        return this.$store.getters.user
      },
      strbirthdate: function () {
        if (this.birthdate) {
          return (this.birthdate.toISOString().split('T')[0])
        }
      }
    }
  }
</script>

<style scoped>
   .customdate {
    position: relative;
  }

  .vdp-datepicker input {
    background: #ffffff !important;
  }

  .customdate .input-group-addon {
    position: absolute;
    right: 0;
    z-index: -1;
    top: 0;
    height: 100%;
    border-radius: 10px;
  }

  .customdate .vdp-datepicker {
    width: 100%;
  }
  .modal {
    background-color: rgba(0, 0, 0, 0.7);
  }

  .closebtn {
    float: right;
    text-align: right;
    color: #fff;
    padding: 5px;
    margin-right: -10px;
    margin-bottom: -6px;
    border-radius: 0 5px 5px 0;
    cursor: pointer;
  }

  .modalcon {
    position: fixed;
    display: block;
    left: 0;
    z-index: 9998;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    overflow-x: hidden;
    overflow-y: auto;
    transition: opacity .3s ease;
  }

  .modal-mask {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: table;
  }

  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
  }

  .modal-container {
    width: 400px;
    margin: 0px auto;

    transition: all .3s ease;
  }

  .mbox {
    background: #fff;
    padding: 10px;
    border-radius: 2%;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  }

  .modal-header, .modal-body {
    padding: 5px;
  }

  .modal-header h3 {
    margin-top: 0;
    color: #42b983;
  }

  .modal-body {
    margin: 20px 0;
  }

  .modal-default-button {
    float: right;
  }

  .modal-enter {
    opacity: 0;
  }

  .modal-leave-active {
    opacity: 0;
  }

  .modal-enter .modal-container,
  .modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }

  .modal-header {
    border-bottom: none;
  }

  @media screen and (max-width: 768px) {
    .modal-container {
      width: 85%;
    }
  }
</style>



// WEBPACK FOOTER //
// GenderDOBModal.vue?5458fb31